"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_CONFIG = void 0;
var _auth = require("@ori/auth");
// This can be extended by specific types for your Online properties

const DEFAULT_CONFIG = exports.DEFAULT_CONFIG = {
  customerId: _auth.NOT_LOGGED_IN_USER_ID,
  isSimplifiedCheckout: false
};